import {createApp} from 'vue'
import store from './store';
import {setupGlobalErrorLogging} from './components/logger';

import CompareProducts from './../vue/pages/CompareProducts.vue';
import Register from './../vue/pages/Register.vue';
import Checkout from './../vue/pages/Checkout.vue';
import Profile from './../vue/pages/Profile.vue';
import Cart from './../vue/pages/Cart.vue';
import Contact from './../vue/pages/Contact.vue';
import Catalog from './../vue/pages/Catalog.vue';
import Product from './../vue/pages/Product.vue';
import Search from './../vue/pages/Search.vue';
import ProductItem from './../vue/components/product-item/ProductItem.vue';
import ProductPrice from './../vue/components/product-item/ProductPrice.vue';
import ProductCreditPrices from './../vue/components/product/ProductCreditPrices.vue';
import googleReCaptchaV3 from "./../vue/features/GoogleReCaptchaV3.vue";
import TaxSwitcher from "./../vue/features/TaxSwitcher.vue";
import Home from "./../vue/pages/Home.vue";
import Subscriber from "./../vue/components/subscriber/Subscriber.vue";
import HeaderCompareProducts from "./../vue/components/header/HeaderCompareProducts";
import HeaderProfileDropdown from "./../vue/components/header/HeaderProfileDropdown.vue";
import CountrySelector from "./../vue/components/header/CountrySelector.vue";
import imageFullscreenSlider from "./../vue/components/sliders/ImageFullscreenSlider.vue"
import CategoryList from "./../vue/components/home/CategoryList.vue"
import CategoryMenuItem from "../vue/components/categories/CategoryMenuItem.vue"
import OrderReviewsForm from "./../vue/components/review/OrderReviewsForm.vue";

import ModalCompare from "./../vue/modals/ModalCompare.vue"
import ModalProductAddedToCart from "./../vue/modals/ModalProductAddedToCart.vue"

const app = createApp({})

// =====================================================================================================================
// PAGES
// =====================================================================================================================
// Register page components
app.component('compare-products', CompareProducts)
app.component('product', Product)
app.component('contact', Contact)
app.component('catalog', Catalog)
app.component('register', Register)
app.component('checkout', Checkout)
app.component('profile', Profile)
app.component('search', Search)
app.component('cart', Cart)
app.component('home', Home)
app.component('subscriber', Subscriber)


// =====================================================================================================================
// COMPONENTS
// =====================================================================================================================
// Register component dependencies
app.component('google-recaptcha-v3', googleReCaptchaV3)
app.component('tax-switcher', TaxSwitcher)
app.component('product-price', ProductPrice)
app.component('product-credit-prices', ProductCreditPrices)
app.component('product-item', ProductItem)
app.component('header-compare-products', HeaderCompareProducts)
app.component('header-profile-dropdown', HeaderProfileDropdown)
app.component('country-selector', CountrySelector)
app.component('image-fullscreen-slider', imageFullscreenSlider)
app.component('category-list', CategoryList)
app.component('category-menu-item', CategoryMenuItem)
app.component('order-review-form', OrderReviewsForm)

// =====================================================================================================================
// MODALS
// =====================================================================================================================
app.component('modal-compare', ModalCompare)
app.component('modal-product-added-to-cart', ModalProductAddedToCart)

// =====================================================================================================================
// LIBS
// =====================================================================================================================
// Use Vuex store
app.use(store)

// Mount the app to the page
app.mount('#page')

// Pass your Vue app instance and axios
// setupGlobalErrorLogging(app, window.axios);